import { render, staticRenderFns } from "./TreeMerchant.vue?vue&type=template&id=15404974&"
import script from "./TreeMerchant.vue?vue&type=script&lang=js&"
export * from "./TreeMerchant.vue?vue&type=script&lang=js&"
import style0 from "./TreeMerchant.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports